// removed by extract-text-webpack-plugin
module.exports = {"my-posted-demand":"my-posted-demand","list-demand":"list-demand","item-demand":"item-demand","item-demand-content-wrap":"item-demand-content-wrap","item-demand-content":"item-demand-content","item-demand-info-content":"item-demand-info-content","item-demand-updated-time":"item-demand-updated-time","item-demand-desc":"item-demand-desc","btn-see-more-wrap":"btn-see-more-wrap"};


//////////////////
// WEBPACK FOOTER
// ./components/users/my-demand-content/_MyDemandContent.scss
// module id = ./components/users/my-demand-content/_MyDemandContent.scss
// module chunks = 0